// SDO interface for graph configuration — mirrors desktop GraphSettings
// Source: com.odi.api.graph.GraphSettings

export interface GraphSettings {
    uid: string;
    createdBy: string;                // username of creator; used to gate edit/delete
    title: string;
    layout: string;                   // force layout algorithm name
    saveNodePositions: boolean;
    rootNodes: GraphRootNode[];

    // Font overrides
    fontOverrideEnabled: boolean;
    fontFamily: string;
    fontSize: number;
    fontBold: boolean;
    fontItalic: boolean;
    fontUnderline: boolean;
    fontColorHex: string;

    // Node color overrides
    rootNodeColorEnabled: boolean;
    rootNodeColorHex: string;
    resourceNodeColorEnabled: boolean;
    resourceNodeColorHex: string;
    intelNodeColorEnabled: boolean;
    intelNodeColorHex: string;

    // Edge style overrides
    edgeStyleEnabled: boolean;
    edgeColorHex: string;
    edgeStrokeWidth: number;
    edgeStrokeStyle: string;          // "SOLID" | "DASHED" | "DOTTED"
}

export interface GraphRootNode {
    uid: string;
    display: string;
    typeKey: string;
    profileType: string;              // "INTEL" | "RESOURCE" | "ASSOCIATION"
}

export function createDefaultGraphSettings(): GraphSettings {
    return {
        uid: "",
        createdBy: "",
        title: "New Graph",
        layout: "FORCE",
        saveNodePositions: false,
        rootNodes: [],
        fontOverrideEnabled: false,
        fontFamily: "Montserrat",
        fontSize: 12,
        fontBold: false,
        fontItalic: false,
        fontUnderline: false,
        fontColorHex: "#FFFFFF",
        rootNodeColorEnabled: false,
        rootNodeColorHex: "#02cfee",
        resourceNodeColorEnabled: false,
        resourceNodeColorHex: "#38ff82",
        intelNodeColorEnabled: false,
        intelNodeColorHex: "#02cfee",
        edgeStyleEnabled: false,
        edgeColorHex: "#808080",
        edgeStrokeWidth: 1.0,
        edgeStrokeStyle: "SOLID",
    };
}
